import { IMAGE_HEADER_CONTAINER_ID } from 'Container/App/constants';
import { mountLoadingSpinner } from 'Component/LoadingSpinner';
import { mountImageHeader } from 'Component/ImageHeader';
import { mountErrorNotification } from 'Component/Notification';
import getAvailableSubscriptionIds from 'Container/App/helpers/getAvailableSubscriptionIds';
import mountTariffCard from 'Component/TariffCard';
import getCustomerConfig from 'Container/App/helpers/getCustomerConfig';
import { setInitialState } from 'Container/App/slice';
import { useDispatch } from '../../store';
import { mountCashbackPromotionalCard } from 'Component/PromotionalCard';
import { startListeners } from './listener';

const mountRedplusAppContainer = () => {
    startListeners();

    const dispatch = useDispatch();
    // Mount components
    mountLoadingSpinner();
    mountErrorNotification();
    mountCashbackPromotionalCard();
    const tariffCards = mountTariffCard();

    // Just mount to enable functionality
    mountImageHeader(IMAGE_HEADER_CONTAINER_ID);

    dispatch(setInitialState(getAvailableSubscriptionIds(tariffCards), getCustomerConfig()));

    window.addEventListener('pageshow', event => {
        if (event.persisted) {
            // Read initial state from storage
            dispatch(setInitialState(
                getAvailableSubscriptionIds(tariffCards),
                getCustomerConfig(),
            ));
        }
    });
};

export default mountRedplusAppContainer;
